// extracted by mini-css-extract-plugin
export default {"container":"AssetPositionTooltip_container__ow8sh","title":"AssetPositionTooltip_title__jRpjw"};